import FormErrorMessage from '@components/FormErrorMessage';
import PlacingOrderButtons from '@components/PlacingOrderButtons';
import PlacingOrderHeader from '@components/PlacingOrderHeader';
import { ButtonType } from '@components/Button';
import { cancelReturn } from '@api/apiClient';
import { Grid } from '@components/Grid';
import { IDisposalQueueModalWindowProps } from '../types';
import { isFuture } from 'date-fns';
import moment from 'moment';
import { useMutation } from "react-query";
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const DisposalQueueModalWindow: React.FC<IDisposalQueueModalWindowProps> = (props: IDisposalQueueModalWindowProps): React.ReactElement => {
  const { onClose, parcelId, estimatedUtilizationDate, onSuccess, tabType } = props;
  const [minutes, setMinutes] = useState(0);
  const [hours, setHours] = useState(0);

  const { t } = useTranslation();

  const {
    error: errorCancelReturn,
    isError: isErrorCancelReturn,
    isLoading: isLoadingCancelReturn,
    mutate: mutateCancelReturn
  } = useMutation({
    mutationFn: cancelReturn,
    onSuccess() {
      onClose();
      onSuccess();
    }
  });

  const handleTimer = (interval?: any) => {
    if (isFuture(estimatedUtilizationDate)) {
      setHours(moment(estimatedUtilizationDate).diff(moment(), 'hours'));
      setMinutes(moment(estimatedUtilizationDate).diff(moment(), 'minutes'));
    } else {
      setHours(0);
      setMinutes(0);
      if (interval) clearInterval(interval);
    }
  }

  useEffect(() => {
    handleTimer();
    if (!estimatedUtilizationDate || !isFuture(estimatedUtilizationDate)) {
      return () => {};
    }
    const interval = setInterval(() => {
      handleTimer(interval)
    }, 1000);

    return () => {
      clearInterval(interval);
    }
  }, []);

  const context = (() => {
    if (!isFuture(estimatedUtilizationDate)) {
      return tabType;
    }
    if (hours) return "hours";
    return "minutes";
  })()

  return (
    <Grid>
      <PlacingOrderHeader
        description={t(`disposalQueueModalWindow.description`, { context, count: context === 'minutes' ? minutes : hours })}
        title={t('disposalQueueModalWindow.title')}
      />
      <PlacingOrderButtons
        buttons={[
          {
            action: () => mutateCancelReturn(parcelId),
            disabled: isLoadingCancelReturn,
            text: t(isFuture(estimatedUtilizationDate) ? 'disposalQueueModalWindow.continueBtn' : 'disposalQueueModalWindow.recycle'),
            type: ButtonType.SKELETON
          }, {
            action: onClose,
            disabled: isLoadingCancelReturn,
            text: t('disposalQueueModalWindow.cancel'),
            type: ButtonType.BLOCK
          }
        ]}
      />
      {isErrorCancelReturn && <FormErrorMessage error={errorCancelReturn}/>}
    </Grid>
  );
};

export default DisposalQueueModalWindow;
